<template>
    <div class="h-auto">
        <router-view name="AppHeader"/>
        <router-view name="AppSidebar"/>
        <div class="h-auto desktop:ml-[17.25rem] mb-60" :class="{'blur-content': showConfirmModal}">
            <router-view/>
        </div>
    <confirmation-modal
        v-if="showConfirmModal"
        @submit="validate($event)"
        @close="showConfirmModal = false"
        :error-message="modalErrorMessage"
        :email="authStore.user.email"
    />
    </div>
    <app-footer/>
</template>

<script setup>
import AppFooter from "./components/AppFooter";
import ConfirmationModal from "./components/ConfirmationModal";
import {storeToRefs} from "pinia";
import {useAuthStore} from "./store/auth";
import {ref} from "vue";

const authStore          = useAuthStore();
const {showConfirmModal} = storeToRefs(authStore);
const modalErrorMessage  = ref(null);

function validate(e) {
    authStore.validateCode(e)
        .then(response => {
            console.log(response)
        }).catch(error => {
        modalErrorMessage.value = error.message;
    });
}
</script>

<style>
.blur-content{
    filter: blur(5px);
}
</style>
